import { ROOT_COLORS } from './RegionHierarchyTree';

interface Props {
  /** Root region name, shown when a subregion is selected (inherited color). */
  rootName: string;
  isRootSelected: boolean;
  currentColor: string;
  onPick: (color: string) => void;
  saving?: boolean;
}

/**
 * Swatch picker for a region's color. Color lives on the root region and
 * cascades to its subregions, so selecting always targets the root.
 */
export function RegionColorPicker({
  rootName,
  isRootSelected,
  currentColor,
  onPick,
  saving,
}: Props) {
  return (
    <div>
      <div className="nb-eyebrow" style={{ fontSize: 9, marginBottom: 6 }}>
        Region color
        {!isRootSelected && (
          <span style={{ textTransform: 'none', fontWeight: 500, color: 'var(--nb-faint)' }}>
            {' '}
            · inherited from {rootName}
          </span>
        )}
      </div>
      <div style={{ display: 'flex', flexWrap: 'wrap', gap: 6, opacity: saving ? 0.5 : 1 }}>
        {ROOT_COLORS.map((col) => {
          const on = currentColor.toLowerCase() === col.toLowerCase();
          return (
            <button
              key={col}
              type="button"
              title={col}
              aria-label={`Set region color ${col}`}
              aria-pressed={on}
              disabled={saving}
              onClick={() => onPick(col)}
              style={{
                width: 22,
                height: 22,
                borderRadius: 6,
                background: col,
                padding: 0,
                cursor: saving ? 'default' : 'pointer',
                border: on ? '2px solid var(--nb-ink)' : '2px solid transparent',
                boxShadow: on ? 'none' : 'inset 0 0 0 1px rgba(0,0,0,.08)',
              }}
            />
          );
        })}
      </div>
    </div>
  );
}
